<div class="blog-top">  
  <div class="top-title">
  <div class="title">Gizlilik Politikaları</div>
  <div class="b-title">
    <div class="slogan">Hüküm Koşullar & Aydınlatma Metni & KVKK</div>
  </div>
</div></div>
<div class="container">
  <div class="row articles">
    <div class="row p0">
      <div class="col-md-4 p0" *ngFor="let policy of policies">
        <div class="client-item item">
          <div class="img">
            <a [routerLink]="policy.pageUrl">
              <app-img-view [imageUrl]="policy.imageUrl"></app-img-view>
            </a>
          </div>
          <div class="client-body">
            <span class="client--content a-title">
              <h3>{{ policy.title }}</h3>
            </span>
            <div class="client-btn">
              <a [routerLink]="policy.pageUrl">
                <img src="../../../assets/images/arrow-right.svg" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>